var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 18,
    viewBox: "0 0 53 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 52.8,
    height: 17.8,
    rx: 7.9,
    fill: "url(#paint0_linear_99_3107)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 52.8,
    height: 17.8,
    rx: 7.9,
    stroke: "url(#paint1_linear_99_3107)",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0327 4.27273V13H18.6264L14.5142 7.0554H14.4418V13H12.8608V4.27273H14.2756L18.3835 10.2216H18.4602V4.27273H20.0327ZM21.7553 13V4.27273H27.4315V5.59801H23.3363V7.96733H27.1374V9.29261H23.3363V11.6747H27.4656V13H21.7553ZM30.881 13L28.418 4.27273H30.1183L31.6907 10.6861H31.7717L33.4506 4.27273H34.9975L36.6808 10.6903H36.7575L38.3299 4.27273H40.0302L37.5671 13H36.0075L34.2603 6.87642H34.1921L32.4407 13H30.881Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_3107",
    x1: 26,
    y1: -6.99723e-7,
    x2: 26,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_3107",
    x1: 26,
    y1: 5.87128e-8,
    x2: 28.2383,
    y2: 17.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015FB4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelNew);
export default __webpack_public_path__ + "static/media/label_new.488b0f767e1ea9ab6289884bd59117ed.svg";
export { ForwardRef as ReactComponent };